<template>
  <div class="flex" style="position: relative;">
    <Goback :title="'返回'" style="position: absolute;left: 20%;top:5%;z-index: 10;"></Goback>
    <Overview :batteryInfo="batteryInfo" style="position: absolute;left: 0px;top: 0px;z-index: 10;"/>
    <!-- <batteryBox/> -->
    <batteryBag/>
    <div class="flex flex-direction" style="position: absolute;right: 0px;top: 0px;">
      <SiteType :batteryInfo="batteryInfo"/>
    </div>
  </div>
</template>

<script>
//综合态势
import Goback from "@/components/goBack.vue";
import Overview from "@/views/batteryBox/overview.vue";
// import batteryBox from "@/views/batteryBox/batteryBox";
import batteryBag from "@/views/batteryBag/batteryBag";
import SiteType from "@/views/batteryBox/siteType.vue";


export default {
  data () {
    return {
      batteryInfo:{},
    };
  },
  components: {
    Overview,
    // batteryBox,
    SiteType,
    batteryBag,
    Goback
  },
  props: {
    
  },
  watch: {
    
  },
  methods: {
    getData(data){
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
</style>